/* eslint-disable no-unwrapped-jsx/no-unwrapped-jsx-text */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import React, { useState, useEffect } from 'react';
import { Utils } from 'Utils/utils';
import { observer } from 'mobx-react';
import { userDetail } from 'Stores/userDetail';
import * as CONSTANTS from 'Utils/constants';
import NumberFormat from 'react-number-format';
import { myLeadsState } from 'Stores/myLeads';
import { ReactComponent as DeleteFromListIcon } from 'Assets/svg/new_icons/deleteFromList.svg';
import { commonMsgPopupState } from 'Components/common/commonMsgPopup';
import { CheckBox } from 'Components/common/CheckBox';
import {
  ExportLeads,
  exportLeadsState,
} from 'Components/common/ExportLeads/exportLeads';
import Dropdown from 'Components/common/dropdown';
import SharedListIcon from 'Components/common/SharedListIcon';
import { ReactComponent as LockIcon } from 'Assets/svg/lock.svg';
import { ReactComponent as RightArrowIcon } from 'Assets/usageAnalytics/right-arrow.svg';
import { ReactComponent as DropDownIcon } from 'Assets/svg/dropdown-icon.svg';
import { ReactComponent as NewFilterIcon } from 'Assets/svg/new-filter-icon.svg';
import { ReactComponent as NewExportToIcon } from 'Assets/svg/new-export-icon.svg';
import { myLeadsList } from 'Utils/commonApi';
import DropDownForRoleAndUpdates from './HoverDropdown';
import './styles/deleteContactsPopup.scss';

const { EXPORT_SOURCE } = CONSTANTS;
const { MY_LEADS } = EXPORT_SOURCE;

const MiddleSection = observer(props => {
  const {
    jobUpdateAvailable,
    currentTab,
    history,
    location,
    popUpFunction,
    listId,
    handleDayFilter,
    dayFilter = {},
    listData = { isSharedList: false },
  } = props;
  const [showMask, setShowMask] = React.useState(false);
  const listForActionRef = React.createRef(null);
  const [actions, setActions] = React.useState(null);
  const [showMoveToListPopup, setShowMoveToListPopup] = React.useState(false);
  const [showFilter, setShowFilter] = useState(null);

  function handleClickOutside(event) {
    console.log(event);
    if (
      listForActionRef.current &&
      !listForActionRef.current?.contains(event.target) &&
      showMoveToListPopup
    )
      setShowMoveToListPopup(false);
  }
  const closeActionMask = e => {
    if (e !== null && e !== undefined) e.stopPropagation();
    setShowMask(false);
    setShowFilter(null);
    setShowMoveToListPopup(false);
  };

  useEffect(() => {
    if (showMoveToListPopup)
      document.addEventListener('click', handleClickOutside, true);
    return () => {
      // eslint-disable-next-line no-undef
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [showMoveToListPopup]);

  const purchaseContacts = id => {
    myLeadsState.setActionLoader(true);
    myLeadsState.purchaseContactsForMyLeads({
      ids: myLeadsState.bulkPurchaseIds,
      listId: id,
      callback: () => {
        myLeadsState.setActionLoader(false);
      },
    });
  };

  const listAction = (e, id, name, actionMethod) => {
    closeActionMask();
    if (actionMethod === 'add')
      if (currentTab === 1) {
        purchaseContacts(id);
      } else myLeadsState.addToAnotherList(id, name);
    else myLeadsState.moveToAnotherList(id, name);
  };

  const deleteLeadsFromList = e => {
    if (myLeadsState.bulkPurchaseIds.length > 0) {
      const closePopup = () => {
        commonMsgPopupState.setShowMsgPopup(false);
        myLeadsState.clearPreviouslySelectedConatcts();
      };
      const callback = async () => {
        await myLeadsState.deleteFromList(
          myLeadsState.selectedList.id,
          myLeadsState.selectedList.name,
        );
        
        closePopup();
      };

      commonMsgPopupState.setPopupValues({
        title: 'Remove from List',
        description: 'Are you sure about removing the selected contacts from this list?',
        btnText: 'Yes',
        customClassName: 'my-leads-action-popup delete-contacts-popup',
        actionBtnCallback: callback,
        clickOutsidePopupCallback: closePopup,
        closeClickCallback: closePopup,
        showCancelBtn: true,
        showCloseBtn: true,
        cancelBtnText: 'Cancel',
        cancelBtnCallback: closePopup,
        svgImgComponent: <DeleteFromListIcon />,
        customParentClassName: 'delete-from-list',
      });
      commonMsgPopupState.setShowMsgPopup(true);
    }
  };

  const showExportOptions = (e, source, exportOption, count) => {
    exportLeadsState.setExportSource(MY_LEADS);
    Utils.mixpanelTrack(CONSTANTS.MX_ML_EVENTS.ML_EXPORT_CLICK, {
      optionType: exportOption,
      selectedCount: count,
      currentTab: CONSTANTS.MY_LEADS_TABS[currentTab],
    });
    const callback = () => {
      myLeadsList(false);
    };
    const customExportCallback = {
      CSV: () => {
        myLeadsState.setActionLoader(true);
        myLeadsState.purchaseContactsForMyLeads({
          ids: myLeadsState.bulkPurchaseIds,
          listId: myLeadsState.selectedList.id,
          callback: () => {
            myLeadsState.setActionLoader(false);
          },
          type: CONSTANTS.CONTACT_EXPORT_TYPES.DIRECT_EXPORT,
          exportType: 'CSV',
        });
      },
    };
    exportLeadsState.setExportOption(exportOption);
    exportLeadsState.setShowExportLeads(
      true,
      currentTab === 1 ? { callback, customExportCallback } : {},
    );
  };

  const RenderLeadListForAction = React.forwardRef((prop, ref) => {
    const { action } = prop;
    const leadList = userDetail.myLeadList;
    const selectedListId = myLeadsState.selectedList.id;
    const leadListView = leadList.map((item, index) => {
      if (item.id !== selectedListId && item.id !== null)
        return (
          <div
            className="leads-list-item"
            key={`leads-item_${index}`}
            onClick={e => listAction(e, item.id, item.name, action)}
          >
            <i className="fa fa-folder-o v-btm" />
            <span className="lead-name show-elipsis" title={item.name}>
              {item.name}
            </span>
            <SharedListIcon data={item} />
            <span className="lead-count">
              <NumberFormat
                thousandSeparator
                thousandsGroupStyle="lakh"
                displayType="text"
                value={item.count}
              />
            </span>
          </div>
        );
      return '';
    });

    return (
      <div
        className={`myleads-action-drop-box animatedFast animatedDropDown ${
          action === 'move' ? 'action-drop-down-for-move' : ''
        }`}
        ref={ref}
      >
        <div className="leads-list-popup more-actions-list">
          <div className="leads-list">{leadListView}</div>
        </div>
      </div>
    );
  });

  const selectedListName = myLeadsState.selectedList.name;

  const showPricingPopup = (e, key) => {
    if (e !== null) e.stopPropagation();
    Utils.upgradeNowClick('list_building');
  };

  const addToBulk = (e, key) => {
    if (e !== null && e !== undefined) e.stopPropagation();
    setActions(key);
    if (myLeadsState.bulkPurchaseIds.length > 0) setShowMoveToListPopup(true);
  };

  const moveToBulk = (e, key) => {
    if (e !== null && e !== undefined) e.stopPropagation();
    setActions(key);
    if (myLeadsState.bulkPurchaseIds.length > 0) setShowMoveToListPopup(true);
  };

  const formatNumberWithText = (number, text = '', showContactText = true) => {
    return number !== undefined && number !== null ? (
      <>
        {Utils.usNumberFormat(number)}
        &nbsp;{text}
        {showContactText && <>{number > 1 ? 'contacts' : 'contact'}&nbsp;</>}
      </>
    ) : (
      ''
    );
  };
  const handleOnClickDays = (tab, days) => {
    setShowFilter(null);
    handleDayFilter(tab, days);
    setShowMask(false);
  };

  const closeHoverPopUp = () => {
    setShowFilter(null);
    setShowMask(false);
  };

  const selectedRowsinPage = e => {
    e.stopPropagation();
    myLeadsState.updateSelectedBulkContactAll();
    setShowMask(false);
  };

  const onClickBulkPurchase = () => {
    if (Utils.checkIsEmailVerified(true)) {
      const callback = () => {
        myLeadsState.setActionLoader(true);
        myLeadsState.purchaseContactsForMyLeads({
          ids: myLeadsState.bulkPurchaseIds,
          listId,
          callback: () => {
            myLeadsState.setActionLoader(false);
            myLeadsState.clearPreviouslySelectedConatcts();
          },
        });
      };
      Utils.mixpanelTrack(
        CONSTANTS.MX_CONTACT_UPDATE_EVENTS.JOB_CHANGES_BULK_PURCHASE_CLICKED,
        { contactsCount: myLeadsState.bulkPurchaseIds.length },
      );
      Utils.checkUserHasEnoughCredits(
        myLeadsState.bulkPurchaseIds,
        'add to list',
        callback,
      );
    }
  };
  return (
    <>
      <ExportLeads
        {...(listData.isSharedList
          ? { enabledExportTypes: ['CSV'] }
          : currentTab === 1
          ? {
              enabledExportTypes: ['CSV', 'Salesforce', 'Hubspot'],
            }
          : {})}
      />
      <div className="leads-action-wrapper">
        <div className="adv-contact-action-btn-wrap">
          <div className="select-action-button-parent">
            <div
              className={`contact-action-btn more-actionst selected-action-btn${
                myLeadsState.leadsResultCount === 0 ? ' btn-disabled' : ''
              }`}
              onClick={() => {
                if (myLeadsState.leadsResultCount > 0) setShowMask(true);
              }}
            >
              <div className="contact-chechk-box-wrap leads-check-box">
                <CheckBox
                  onClick={e => {
                    if (myLeadsState.leadsResultCount > 0)
                      selectedRowsinPage(e);
                  }}
                  dymamicClass={
                    myLeadsState.allContactSelected ? 'selected' : ''
                  }
                />
              </div>
              {(myLeadsState.bulkPurchaseIds.length > 0 ||
                myLeadsState.bulkPurchaseIds.length > 0) && (
                <div className="selected-count selected-count-text">
                  {formatNumberWithText(
                    currentTab === 1
                      ? myLeadsState.bulkPurchaseIds.length
                      : myLeadsState.bulkPurchaseIds.length,
                    '',
                    false,
                  )}
                  <span>selected</span>
                </div>
              )}
            </div>
          </div>
          {currentTab === 0 ? (
            <div
              className={`export-button-wrap${
                myLeadsState.leadsResultCount === 0 ? ' btn-disabled' : ''
              }`}
            >
              <Dropdown
                className="myleads-action-drop-box"
                wrapperClassName="export-dropdown"
                toggleElement={
                  <div className="contact-action-btn export-all-btn">
                    <NewExportToIcon className="svg-icon" />
                    Export &nbsp;
                    <i
                      className="fa fa-caret-down dropdown-icon"
                      aria-hidden="true"
                    />
                  </div>
                }
              >
                <div className="leads-list-popup export-selection">
                  <div className="leads-list">
                    <div
                      className="leads-list-item"
                      onClick={e =>
                        showExportOptions(
                          e,
                          'salesLift',
                          'export all',
                          myLeadsState.leadsResultCount,
                        )
                      }
                    >
                      <span className="lead-name">Export All</span>
                      <span className="lead-count">
                        (
                        <NumberFormat
                          thousandSeparator
                          thousandsGroupStyle="lakh"
                          displayType="text"
                          value={myLeadsState.leadsResultCount}
                        />
                        )
                      </span>
                    </div>

                    {myLeadsState.bulkPurchaseIds.length > 0 && (
                      <div
                        className="leads-list-item"
                        onClick={e =>
                          showExportOptions(
                            e,
                            'salesLift',
                            'export selected',
                            myLeadsState.bulkPurchaseIds.length,
                          )
                        }
                      >
                        <span className="lead-name">Export Selected</span>
                        <span className="lead-count">
                          (
                          <NumberFormat
                            thousandSeparator
                            thousandsGroupStyle="lakh"
                            displayType="text"
                            value={myLeadsState.bulkPurchaseIds.length}
                          />
                          )
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </Dropdown>
            </div>
          ) : (
            <div
              className={`contact-action-btn export-all-btn export-button${
                myLeadsState.bulkPurchaseIds.length > 0 ? '' : ' btn-disabled'
              }`}
            >
              <span
                onClick={e =>
                  showExportOptions(
                    e,
                    'salesLift',
                    currentTab === 1 ? 'job update' : 'export selected',
                    myLeadsState.bulkPurchaseIds.length,
                  )
                }
              >
                <NewExportToIcon className="svg-icon" />
                Export
              </span>
            </div>
          )}

          <div
            className={`bulk-action-mask${showMask ? ' show-mask' : ''}`}
            onClick={closeActionMask}
          />
          {currentTab === 1 && myLeadsState.bulkPurchaseIds.length > 0 && (
            <div className="bulk-purchase-wrapper">
              <div
                className="contact-action-btn export-btn bulk-button export-all-btn"
                onClick={onClickBulkPurchase}
              >
                Bulk Purchase
              </div>
            </div>
          )}

          {myLeadsState.bulkPurchaseIds.length > 0 && !listData.isSharedList ? (
            userDetail.featureFlags !== null &&
            userDetail.featureFlags.LIST_BUILDING !== undefined &&
            userDetail.featureFlags.LIST_BUILDING === false ? (
              <Dropdown
                className="blocked-wrap more-actions"
                align="end"
                toggleElement={
                  <div className="contact-action-btn export-btn">
                    More Actions &nbsp;
                    <LockIcon className="dropdown-icon plus-icon lock-icon" />
                  </div>
                }
              >
                <div className="phoneUpgrade filterLockUpgrade">
                  <div className="phoneUpgradeWrap">
                    <div className="up-text">
                      Upgrade to add/move to other lists or delete contacts
                    </div>
                    <div
                      onClick={e => showPricingPopup(e, 'Add new')}
                      className="locked-numbers-upgrade"
                    >
                      {Utils.getLockFilterBtnText()}
                    </div>
                  </div>
                </div>
              </Dropdown>
            ) : (
              <Dropdown
                className="more-actions-wrapper"
                toggleElement={
                  <div className="contact-action-btn export-btn">
                    More Actions &nbsp;&nbsp; &nbsp;
                    <DropDownIcon className="export-dropdown-icon" />
                  </div>
                }
              >
                <div className="other-updates-dropdown more-actions-dropdown-wrapper more-actions-dropdown">
                  {showMoveToListPopup && (
                    <RenderLeadListForAction
                      action={actions}
                      ref={listForActionRef}
                    />
                  )}
                  {((userDetail.myLeadList.length > 0 &&
                    userDetail.myLeadList.length !== 1) ||
                    selectedListName === 'All Leads') && (
                    <div onClick={e => addToBulk(e, 'add')}>
                      Add contacts to list{' '}
                      <RightArrowIcon className="arrow-icon" />
                    </div>
                  )}
                  {selectedListName !== 'All Leads' &&
                    selectedListName !== 'Plugin History' &&
                    userDetail.myLeadList.length !== 1 &&
                    currentTab !== 1 && (
                      <div
                        className="move-item"
                        onClick={e => moveToBulk(e, 'move')}
                      >
                        Move selected contacts{' '}
                        <RightArrowIcon className="arrow-icon" />
                      </div>
                    )}
                  {selectedListName !== 'All Leads' &&
                    selectedListName !== 'Plugin History' &&
                    currentTab !== 1 && (
                      <>
                        <div className="marginBothSides margin-line" />
                        <div className="dlt-item" onClick={deleteLeadsFromList}>
                          Delete Selection
                        </div>
                      </>
                    )}
                </div>
              </Dropdown>
            )
          ) : null}
        </div>

        {userDetail.isContactUpdatesEnabled && !listData.isSharedList && (
          <div>
            <div className="my-leads-list-tab-wrapper">
              <span
                className={currentTab === 0 ? 'active' : ''}
                onClick={() => {
                  if (currentTab !== 0)
                    history.push(`${location.pathname}?tab=0`);
                }}
              >
                <p>All Contacts</p>
              </span>
              <span
                className={currentTab === 1 ? 'active' : ''}
                onClick={() => {
                  if (userDetail.isJobChangesEnabled) {
                    if (currentTab !== 1)
                      history.push(`${location.pathname}?tab=1`);
                  } else {
                    popUpFunction();
                  }
                }}
              >
                <p>Job Changes</p>
                {jobUpdateAvailable && currentTab !== 1 && (
                  <div className="ripple-effect job-changes-ripple-effect" />
                )}
              </span>
              <span
                className={currentTab === 2 ? 'active ' : ''}
                onClick={() => {
                  if (currentTab !== 2) {
                    if (dayFilter.role) {
                      history.push(`${location.pathname}?tab=2`);
                    } else {
                      setShowFilter(2);
                      setShowMask(true);
                    }
                  } else {
                    setShowFilter(2);
                    setShowMask(true);
                  }
                }}
              >
                <span>
                  <p>Role Changes</p>
                  <NewFilterIcon />
                </span>{' '}
                {showFilter === 2 && (
                  <DropDownForRoleAndUpdates
                    selectedValue={dayFilter.role}
                    updatedFlag={false}
                    currentTab={2}
                    handleOnClickDays={days => {
                      if (currentTab !== 2) {
                        history.push(
                          `${location.pathname}?tab=2&noOfDays=${days}`,
                        );
                        closeHoverPopUp();
                      } else {
                        handleOnClickDays('role', days);
                      }
                    }}
                    closeHoverPopUp={closeHoverPopUp}
                  />
                )}
              </span>
              <span
                className={currentTab === 3 ? 'active other-updates' : ''}
                onClick={() => {
                  if (currentTab !== 3) {
                    if (dayFilter.other) {
                      history.push(`${location.pathname}?tab=3`);
                    } else {
                      setShowFilter(3);
                      setShowMask(true);
                    }
                  } else {
                    setShowFilter(3);
                    setShowMask(true);
                  }
                }}
              >
                <span>
                  <p>Other Updates</p>
                  <NewFilterIcon />
                </span>
                {showFilter === 3 && (
                  <DropDownForRoleAndUpdates
                    selectedValue={dayFilter.other}
                    updatedFlag={false}
                    currentTab={3}
                    handleOnClickDays={days => {
                      if (currentTab !== 3) {
                        closeHoverPopUp();
                        history.push(
                          `${location.pathname}?tab=3&noOfDays=${days}`,
                        );
                      } else {
                        handleOnClickDays('other', days);
                      }
                    }}
                    closeHoverPopUp={closeHoverPopUp}
                  />
                )}
              </span>
            </div>
          </div>
        )}
      </div>
    </>
  );
});

export default MiddleSection;
